<footer class="modern-footer" #footerRoot>
  <div class="container footer-main-container">
    <div class="footer-shell">
      <div class="footer-brand footer-reveal" data-reveal="card" style="--reveal-order: 0">
        <img src="assets/brand/logo.png" alt="Grupo DINGO" class="footer-logo">
        <p class="brand-description">
          Agencia omnicanal y central de medios. Estrategias 360° para maximizar el valor de tu marca.
        </p>
        <div class="footer-social">
          <a href="https://www.facebook.com/profile.php?id=100063605347598" class="footer-social-icon" target="_blank" rel="noopener" aria-label="Facebook">
            <i class="bi bi-facebook"></i>
          </a>
          <a href="https://www.instagram.com/dingomarketing_?igsh=MWY0cXRzNTM1dHNraA%3D%3D&utm_source=qr" class="footer-social-icon" target="_blank" rel="noopener" aria-label="Instagram">
            <i class="bi bi-instagram"></i>
          </a>
          <a href="https://wa.me/5215543581515" class="footer-social-icon" target="_blank" rel="noopener" aria-label="WhatsApp">
            <i class="bi bi-whatsapp"></i>
          </a>
        </div>
      </div>

      <nav class="footer-section footer-reveal" data-reveal="card" style="--reveal-order: 1" aria-label="Servicios">
        <h5 class="footer-section-title">Servicios</h5>
        <ul class="footer-links">
          <li><a routerLink="/servicios/marketing-digital">Marketing Digital</a></li>
          <li><a routerLink="/servicios/desarrollo-apps">Desarrollo de Apps</a></li>
          <li><a routerLink="/servicios/publicidad">Publicidad</a></li>
          <li><a routerLink="/servicios/data-science">Data Science</a></li>
        </ul>
      </nav>

      <nav class="footer-section footer-reveal" data-reveal="card" style="--reveal-order: 2" aria-label="Navegación">
        <h5 class="footer-section-title">Navegación</h5>
        <ul class="footer-links">
          <li><a routerLink="/inicio">Inicio</a></li>
          <li><a routerLink="/acerca">Acerca</a></li>
          <li><a routerLink="/servicios">Servicios</a></li>
          <li><a routerLink="/contacto">Contacto</a></li>
        </ul>
      </nav>

      <div class="footer-section footer-contact footer-reveal" data-reveal="card" style="--reveal-order: 3">
        <h5 class="footer-section-title">Contacto</h5>
        <div class="footer-contact-info">
          <div><i class="bi bi-geo-alt-fill"></i><span>Adolfo Prieto 1145 Interior 3, Col. Del Valle Centro, Benito Juárez, Ciudad de México, CP 03100, México</span></div>
          <div><i class="bi bi-telephone-fill"></i><a href="tel:+5215616635041">+52 1 56 1663 5041</a></div>
          <div><i class="bi bi-envelope-fill"></i><a href="mailto:contacto@grupodingo.com.mx">contacto&#64;grupodingo.com.mx</a></div>
        </div>
        <a routerLink="/contacto" class="footer-cta">
          Contáctanos
          <i class="bi bi-arrow-up-right"></i>
        </a>
      </div>
    </div>

    <div class="footer-bottom footer-reveal" data-reveal="text" style="--reveal-order: 4">
      <div>
        <div class="footer-brand-notice">
          Grupo Dingo es una marca comercial operada por Pleiades Investment Solutions
        </div>
        <div class="footer-copyright">
          © 2026 Pleiades Investment Solutions. Todos los derechos reservados.
        </div>
      </div>
      <div class="footer-bottom-links">
        <a routerLink="/privacidad">Privacidad</a>
        <a routerLink="/terminos">Términos</a>
      </div>
    </div>
  </div>
</footer>
